import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

const Footer = ({ hideCTA = false }) => {
  return (
    <>
      {/*===== CTA AREA STARTS =======*/}
      {!hideCTA && (
        <div
          className="cta5-section-area sp1"
          style={{
            backgroundImage: "url(assets/img/bg/header-bg5.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8 m-auto">
                <div className="cta-header-area text-center heading10">
                  <h2 className="text-anime-style-3">
                    Ready to Start with Panmitra's Services & APIs?
                  </h2>
                  <p data-aos="fade-up" data-aos-duration={1000}>
                    Join 100k+ agents, distributors, and partners using
                    Panmitra's platform. Become a agent, integrate our powerful
                    APIs for PAN Card, recharges, bill payments, and insurance,
                    and start earning commissions immediately.
                  </p>
                  <div
                    className="btn-area1"
                    data-aos="fade-up"
                    data-aos-duration={1200}
                  >
                    <a href="/contact-us" className="header-btn9">
                      Become a Partner <i className="fa-solid fa-arrow-right" />
                    </a>
                    <a
                      href="https://developers.instantpanmitra.com"
                      className="header-btn10"
                    >
                      Explore APIs <i className="fa-solid fa-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/*===== CTA AREA ENDS =======*/}

      {/*===== FOOTER AREA STARTS =======*/}
      <div className="footer1-section-area">
        <div className="container">
          <div className="row">
            {/* Column 1: About & Social */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-logo-area">
                <img src="/images/logo.png" alt="logo" width={130} />
                <p>
                  Panmitra Online Service Pvt. Ltd. is a trusted name in digital
                  & financial services since 2020. We specialize in PAN card
                  processing and seamless utility payments, empowering
                  businesses with cutting-edge technology.
                </p>
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/panmitraonline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="assets/img/icons/facebook.svg" alt="" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/panmitraonline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="assets/img/icons/instagram.svg" alt="" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/919632456111"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="assets/img/icons/linkedin.svg" alt="" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@panmitraonline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="assets/img/icons/youtube.svg" alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 2: Quick Links (Updated) */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-logo-area1">
                <h3>Quick Links</h3>
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/about-us">About Us</a>
                  </li>
                  {/* <li>
                    <a href="/services">Services</a>
                  </li> */}
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/terms-and-conditions">Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="/refund-policy">Refund Policy</a>
                  </li>
                  <li>
                    <a href="/grievance-policy">Grievance Policy</a>
                  </li>
                  <li>
                    <a href="/contact-us">Contact Us</a>
                  </li>
                  <li>
                    <a href="#" target="_blank" className="api-link">
                      Developer APIs
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 3: Our Services */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-logo-area1">
                <h3>Our Services</h3>
                <ul>
                  <li>
                    <a href="/nsdl-pan-card-service">NSDL PAN Card</a>
                  </li>
                  <li>
                    <a href="/offline-pan-card-service">Offline PAN Card</a>
                  </li>
                  <li>
                    <a href="/mobile-and-dth-recharge">Mobile & DTH Recharge</a>
                  </li>
                  <li>
                    <a href="/utility-bill-payments">Utility Bill Payments</a>
                  </li>
                  <li>
                    <a href="/insurance-service">Motor Insurance</a>
                  </li>
                  <li>
                    <a href="/api-solutions">API Solutions</a>
                  </li>
                  {/* <li>
                    <a href="/services">View All Services →</a>
                  </li> */}
                </ul>
              </div>
            </div>

            {/* Column 4: Get in touch */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-logo-area2">
                <h3>Get in touch</h3>
                <ul>
                  <li>
                    <a href="mailto:panmitra121@gmail.com">
                      <img src="assets/img/icons/email.svg" alt="" />
                      <span>panmitra121@gmail.com</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src="assets/img/icons/location.svg" alt="" />
                      <span>
                        PANMITRA ONLINE SERVICE PRIVATE LIMITED, Belagavi,{" "}
                        <br className="d-lg-block d-none" />
                        Karnataka - 590015
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:919632456111">
                      <img src="assets/img/icons/phone.svg" alt="" />
                      <span>+91 9632-456-111</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* GST & CIN Information Row (New) */}
          <div className="row mt-4">
            <div className="col-lg-12">
              <div className="gst-cin-area text-center">
                <p style={{ marginBottom: 0, fontSize: "14px" }}>
                  <strong>GST:</strong> 29AAKCP7179E1ZV &nbsp; | &nbsp;
                  <strong>CIN:</strong> U72200KA2019PTC127019
                </p>
              </div>
            </div>
          </div>

          <div className="space80 d-lg-block d-none" />
          <div className="space40 d-lg-none d-block" />

          {/* Copyright area */}
          <div className="row">
            <div className="col-lg-12">
              <div className="copyright-area">
                <div className="pera">
                  <p>
                    ⓒ Copyright 2026 PANMITRA ONLINE SERVICE PRIVATE LIMITED.
                    All rights reserved
                  </p>
                </div>
                <ul>
                  <li>
                    <a href="/terms-and-conditions">Terms &amp; Conditions</a>
                  </li>
                  <li>
                    <a href="/privacy-policy" className="m-0">
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== FOOTER AREA ENDS =======*/}
    </>
  );
};

export default Footer;
